<template>
  <div class="simple-wrapper">
    <div class="cover-front-title">
      <div class="cover-front-organization-name">{{ organizationName }}</div>
      <div class="cover-front-title-text">
        <img
          :src="
            require('../../../../assets/images/combook_binding/cover_front_title_simple.svg')
          "
          alt="表紙タイトル"
        />
      </div>
      <div class="cover-kid-name">{{ kidName }}</div>
    </div>
    <div class="cover-front-title-text-bg">
      <img
        src="../../../../assets/images/combook_binding/cover_front_bg_simple.png"
        alt="表紙タイトル背景"
      />
    </div>
    <slot name="photo-editor"></slot>
    <div class="cover-front-month-wrapper">
      <div class="cover-front-month">{{ displayYearMonth }}</div>
      <div class="cover-front-number">
        <div>{{ startMonth }}</div>
        <div class="cover-front-number-hyphen">
          <img
            :src="
              require('../../../../assets/images/combook_binding/cover_front_simple_hyphen.svg')
            "
            alt="ハイフン"
          />
        </div>
        <div>{{ endMonth }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "SimpleCover",

  props: {
    organizationName: {
      type: String,
      required: true
    },
    kidName: {
      type: String,
      required: true
    },
    displayYearMonth: {
      type: String,
      required: true
    },
    startMonth: {
      type: String,
      required: true
    },
    endMonth: {
      type: String,
      required: true
    }
  }
});
</script>

<style scoped>
.simple-wrapper {
  font-family: "Noto Sans JP", "Noto Sans SC", "Noto Sans TC", "Noto Sans KR",
    "Noto Sans Devanagari", "Hind Siliguri", "Noto Sans Myanmar",
    "Noto Sans Tamil", "Noto Sans Thai", "Noto Color Emoji", sans-serif !important;
}
/* cover-front-title */
.cover-front-title {
  margin-top: calc(175px * var(--scale-factor));
  margin-left: calc(181px * var(--scale-factor));
  display: flex;
  align-items: flex-start;
  flex-flow: column;
  position: relative;
}

.cover-front-organization-name {
  font-size: calc(64px * var(--scale-factor));
  line-height: 1;
  letter-spacing: calc(2.56px * var(--scale-factor));
  /* 半角スペースを入力通りに表示するため */
  white-space: pre-wrap;
}

.cover-front-title-text {
  width: calc(830px * var(--scale-factor));
  margin: calc(74px * var(--scale-factor)) 0 calc(82px * var(--scale-factor));
}

.cover-front-title-text img {
  width: 100%;
  height: auto;
  display: block;
}

.cover-kid-name {
  font-size: calc(66px * var(--scale-factor));
  line-height: 1;
  letter-spacing: calc(2.64px * var(--scale-factor));
  /* 半角スペースを入力通りに表示するため */
  white-space: pre-wrap;
}

/* cover-front-title-text-bg */
.cover-front-title-text-bg {
  position: absolute;
  top: calc(212px * var(--scale-factor));
  right: calc(212.94px * var(--scale-factor));
  width: calc(169px * var(--scale-factor));
}

.cover-front-title-text-bg img {
  width: 100%;
  height: auto;
  display: block;
}

/* cover-front-month-wrapper */
.cover-front-month-wrapper {
  position: absolute;
  top: calc(473px * var(--scale-factor));
  right: calc(211.9px * var(--scale-factor));
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  font-weight: 400;
  text-align: right;
  font-weight: bold;
}

.cover-front-month {
  font-size: calc(46px * var(--scale-factor));
  line-height: 1;
  text-align: right;
  padding-right: calc(12px * var(--scale-factor));
}

.cover-front-number {
  min-width: calc(330.1px * var(--scale-factor));
  font-size: calc(124px * var(--scale-factor));
  line-height: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: calc(45px * var(--scale-factor));
}

.cover-front-number div {
  line-height: 1;
}

.cover-front-number-hyphen {
  width: calc(29.3px * var(--scale-factor));
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: calc(12px * var(--scale-factor));
  margin-left: calc(12px * var(--scale-factor));
  margin-right: calc(12px * var(--scale-factor));
}

.cover-front-number-hyphen img {
  width: calc(29.3px * var(--scale-factor));
  height: calc(12px * var(--scale-factor));
}
</style>
